<template>
    <div id="app">
        <img class="logo" src="/static/vrs.svg" />
        <h1 class="title">We'll Be Back Soon</h1>
        <p class="dexc">VRS is down for scheduled maintenance and <br/>expect to back online in a few minutes.</p>
        <img :src="image" />
    </div>
</template>

<script>
import image from './maintanence.png';

export default {
    name: 'App',
    data: function () {
        return {
            image: image,
        };
    }
};
</script>

<style>
body{ background-color: #f7f7f7; height: 100vh;
    font-family: sans-serif;}
#app {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.logo {
    width: 150px;
}
.dexc{
    font-size: 20px;
    color: #a2a2a2;
    margin: 0;
}
.title {
        font-size: 50px;
    margin-bottom: 10px;
    margin-top: 10px;
}
</style>
